export abstract class Constants {
	public static readonly PRODUCT_TYPE_MILK = 'milk';
	public static readonly PRODUCT_TYPE_FUEL = 'fuel';
	public static readonly PRODUCT_TYPE_WATER = 'water';
	public static readonly ENTITY_TYPE_FEED_TANK = 'feed_tanks';
	public static readonly ENTITY_TYPE_FUEL_TANK = 'tanks';
	public static readonly ENTITY_TYPE_VAT = 'vats';
	public static readonly ENTITY_TYPE_MILK_VAT = 'vats';
	public static readonly ENTITY_TYPE_WATER_METER = 'water_meters';
	public static readonly ENTITY_TYPE_WATER_TANK = 'water_tanks';
	public static readonly ENTITY_TYPE_WATER_MONITOR = 'water_monitors';
	public static readonly PRODUCT_TYPE_EFFLUENT = 'effluent';
	public static readonly ENTITY_STATE_LIVE = 'live';
	public static readonly ENTITY_STATE_SIGNOFF = 'sign-off';
	public static readonly ENTITY_STATE_INSTALL = 'install';
	public static readonly ENTITY_STATE_PENDING = 'pending';
	public static readonly ENTITY_STATE_REMOVED = 'removed';
	public static readonly ENTITY_STATE_CANCELLED = 'cancelled';
	public static readonly JOB_TYPE_INSTALL = 'install';
	public static readonly JOB_TYPE_REPAIR = 'repair';
	public static readonly JOB_TYPE_REMOVAL = 'remove';
	public static readonly SUPPORTED_COUNTRY_CODES = ['nz', 'au', 'ie', 'gb'];
	public static readonly TERMS_STATE_PENDING_NEW = 'pendingNewTermsSignage';
}

export enum EntityType {
	TRANSCEIVER = 'transceiver',
	SENSOR = 'sensor',
	GATEWAY = 'gateway',
	NODE = 'node',
}

export interface ChangelogHyperlink {
	field: string;
	route: string;
	paramName: string;
}

export const ChangelogHyperlinks: ChangelogHyperlink[] = [
	{ field: 'orgId', route: 'organisations.view', paramName: 'orgId' },
	{ field: 'targetOrgId', route: 'organisations.view', paramName: 'orgId' },
	{ field: 'siteId', route: 'sites.view', paramName: 'siteId' },
	{ field: 'productId', route: 'products.view', paramName: 'productId' },
	{ field: 'transceiverId', route: 'transceivers.view', paramName: 'transceiverId' },
	{ field: 'formulaId', route: 'formulas.view', paramName: 'formulaId' },
	{ field: 'userId', route: 'users.view', paramName: 'userId' },
	{ field: 'adminId', route: 'users.view', paramName: 'userId' },
	{ field: 'nodeId', route: 'nodes.view', paramName: 'nodeId' },
	{ field: 'gatewayId', route: 'gateways.view', paramName: 'gatewayId' },
	{ field: 'tankId', route: 'entity.tank.view', paramName: 'tankId' },
];

export const StatusChangeReasonsLastEntity = [
	'Customer has sold farm/leaving farm',
	'Product is too expensive',
	'Customer changing monitoring provider',
	'Customer changing Partner',
	'Performance issues of product',
	'Partner has requested removal | tank moving',
	'Partner has requested removal | farm no longer in dairy',
	'Reinstall on new site',
	'Product incompatible | unable to install',
	'Administrative correction',
	'Administrative error',
];

export const StatusChangeReasonsRemoval = getStatusChangeReasons(true);
export const StatusChangeReasonsCancel = getStatusChangeReasons(false);

function getStatusChangeReasons(removal: boolean) {
	const action = removal ? 'removed' : 'cancelled';
	return [
		'Entity transferred | New owner',
		`Entity ${action} | By customer`,
		`Entity ${action} | Unable to install`,
		`Entity ${action} | By Partner`,
		`Entity ${action} | Input Error`,
		'Administrative correction',
		'Administrative error',
	];
}
